
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class InputIntegers extends Vue {
  @Prop({ type: Number, required: false, default: 0 }) public minValue: number;
  @Prop({ type: String, required: false, default: '0' }) public id: string;
  @Prop({ type: String, required: false, default: '' }) public variant: string;
  @Prop({ type: Number, required: false, default: 4 }) public digitsNumberBefore: number;
  @Prop({ type: Boolean, required: false, default: false }) public validation: boolean;
  @Prop({ type: Boolean, required: false, default: false }) public disabled: boolean;

  @Prop({ type: String, required: false, default: '' }) public value: string;

  public inputValue = '';

  public incrementValue(): void {
    this.inputValue = String(Number(this.inputValue) + 1);
  }
  public decrementValue(): void {
    if (Number(this.inputValue) - 1 >= this.minValue) {
      this.inputValue = String(Number(this.inputValue) - 1);
    }
  }

  private applyValueFromParent(item: string): void {
    this.inputValue = item;
    this.$forceUpdate();
  }

  @Watch('value', { immediate: true })
  private watchPropValue() {
    this.inputValue = this.value;
  }

  @Watch('inputValue')
  private watchValue() {
    const newValue = this.inputValue.replace(/[^\d.]|\.(?=.*\.)/g, '');
    let newString = '';

    if (newValue.length === 1 && newValue[0] === '.') {
      // First symbol is '.'
      newString = '';
    } else if (newValue[newValue.length - 1] === '.') {
      // Last symbol is '.'
      newString = newValue.split('.')[0].substring(0, this.digitsNumberBefore);
    } else if (newValue.indexOf('.') >= 0 && newValue[newValue.length - 1] !== '.') {
      // Decimal
      newString = newValue.split('.')[0].substring(0, this.digitsNumberBefore);
    } else {
      // Just a number
      newString = newValue.substring(0, this.digitsNumberBefore);
    }

    this.inputValue = newString;

    this.$emit('changed', newString, this.id);
  }
}
